<template>
    <div class="position-box upload">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('langNew4.xydk')}}</div>
        </div>
        <div class="cotainer">
            <div class="cont">
              <div class="upload-tips">{{$t('langNew4.tpsc')}}</div>
              <ul class="upload-ul">
                <li class="upload-li" v-show="isHouse">
                  <div class="upload-box">
                    <img class="upload" v-if="photo_fwxx" :src="photo_fwxx" alt="" @click="upload(1)">
                    <img class="upload" v-else src="@/assets/new4/tianjia.png" alt="" @click="upload(1)">
                  </div>
                  <div class="text">{{$t('wydb.fwxx')}}</div>
                </li>
                <li class="upload-li" v-show="isMoney">
                  <div class="upload-box">
                    <img class="upload" v-if="photo_srzm" :src="photo_srzm" alt="" @click="upload(2)">
                    <img class="upload" v-else src="@/assets/new4/tianjia.png" alt="" @click="upload(2)">
                  </div>
                  <div class="text">{{$t('wydb.srzm')}}</div>
                </li>
                <li class="upload-li" v-show="isBank">
                  <div class="upload-box">
                    <img class="upload" v-if="photo_yhmx" :src="photo_yhmx" alt="" @click="upload(3)">
                    <img class="upload" v-else src="@/assets/new4/tianjia.png" alt="" @click="upload(3)">
                  </div>
                  <div class="text">{{$t('wydb.yhmx')}}</div>
                </li>
                <li class="upload-li" v-show="isCert">
                  <div class="upload-box">
                    <img class="upload" v-if="photo_zjz" :src="photo_zjz" alt="" @click="upload(4)">
                    <img class="upload" v-else src="@/assets/new4/tianjia.png" alt="" @click="upload(4)">
                  </div>
                  <div class="text">{{$t('wydb.zjz')}}</div>
                </li>
              </ul>
              <div class="upload-tips2">{{$t('langNew4.dkts')}}</div>
              <div class="upload-btn buttbg" @click="submit" v-if="isread">{{$t('langNew4.ljdk')}}</div>
              <div class="upload-btn" style="background-color: #999;" v-else>{{$t('langNew4.ljdk')}}</div>
            </div>
            <div class="ruletext">
              <div class="textb">
                <label>
                  <input type="checkbox" checked v-model="isread" />
                  {{$t("我已阅读并知晓")}}
                  <span class="text1" @click="showrule=true">《{{$t("贷款服务协议")}}》</span>
                </label>
              </div>
            </div>
            <div class="rules" v-if="showrule" @click="showrule=!showrule">
              <div class="text1" v-html="rules.content"></div>
            </div>
        </div>
        <div class="load-box" v-show="isLoad" @click="hideLoad"><img class="load" src="@/assets/loading.gif" alt=""></div>
    </div>
</template>

<script>
import lrz from "lrz";
let that = this;
let vm = null;
export default {
    name: 'upload',
    data () {
      return {
        theme: false,
        lang: 'en',
        isLoad: false,
        id: '',
        amount: '',
        imgId: '',
        photo_fwxx: '',
        photo_srzm: '',
        photo_yhmx: '',
        photo_zjz: '',
        isHouse: 0,
        isMoney: 0,
        isBank: 0,
        isCert: 0,
        count: 1,
        rules:{},
        showrule:false,
        isread:false,
      }
    },
    created(){
      vm = this;
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.lang = localStorage.getItem('language') || 'en';
      this.getrule();
    },
    mounted() {
      this.id = this.$route.query.id;
      this.amount = this.$route.query.amount;
      this.getLendImg();
    },
    methods: {
      back(){
        this.$router.go(-1);
      },
      getrule(){
        let that = this;
        this.$ajax.post('/web/getTextsList',{type:'daibixieyi'}).then((res) => {
            let resData = res.data.data;
            if(res.data.code == 1000){
              setTimeout(()=>{
                this.$router.push('/login');
              },1000)
              return false
            }
            that.rules = res.data.data
        }).catch(function(err){
            console.log(err)
        });
      },
      submit(){
        var that = this;
        let data = {
          id: this.id,
          amount: this.amount,
          img_house: this.photo_fwxx,
          img_money: this.photo_srzm,
          img_bank: this.photo_yhmx,
          img_cert: this.photo_zjz,
        }
        if(!this.amount || this.amount <= 0){
            this.$toast.center(this.$t('wydb.qsrje'));
            return;
        }
        if(this.count == 1){
            this.count = 0;
        }else{
            return false;
        }
        this.$ajax.post('/web/lendBuy',data).then((res) => {
            let resData = res.data;
            if(resData.code == 0 || resData.code == 4 || resData.code == 7){
              setTimeout(() => {
                this.count = 1;
                this.$router.push('/currency')
              }, 1000)
            }else{
              this.count = 1;
              this.$toast.center(resData.message);
              return;
            }

        }).catch(function(err){
            console.log(err)
        })
      },
      hideLoad(){
        this.isLoad = false;
      },
      getLendImg(){
        this.$ajax.get('/web/lend_img',{}).then((res) => {
          let resData = res.data.data;
          this.isHouse = resData.img_house;
          this.isMoney = resData.img_money;
          this.isBank = resData.img_bank;
          this.isCert = resData.img_cert;
        }).catch(function(err){
            console.log(err)
        })
      },
      upload(id){
          this.imgId = id;
          this.uploadimg(function (res) {

          })
      },
      uploadimg(callback){
        let that = this;
        that.ele_input(function(res) {
          if (res.length > 0) {
            var formdata = new FormData();
            for (var i = 0, len = res.length; i < len; i++) {
              lrz(res[0]).then(function (rst) {
                var formdata = new FormData();
                let file = new window.File([rst.file],rst.origin.name, {type: rst.file.type});
                formdata.append('file', file);
                formdata.append('token', localStorage.getItem('token'));
                formdata.append('app', 'h5');
                that.isLoad = true;
                $.ajax({
                  url: that.domain + "/web/uploadImg",
                  type: "POST",
                  data: formdata,
                  cache: false,
                  processData: false,
                  contentType: false,
                  success: function(data) {
                    if (typeof data == 'string') data = JSON.parse(data.data)
                    if (data && data.code == 0) {
                      that.isLoad = false;
                      if(that.imgId == 1){
                        that.photo_fwxx = data.data.url;
                      }else if(that.imgId == 2){
                        that.photo_srzm = data.data.url;
                      }else if(that.imgId == 3){
                        that.photo_yhmx = data.data.url;
                      }else{
                        that.photo_zjz = data.data.url;
                      }
                    }else{
                      that.isLoad = false;
                      that.$toast.center(data.message);
                      return;
                    }
                  },error: function(data) {
                    that.isLoad = false;
                    that.$toast.center(data.message);
                    return;
                  }
                });
              })
            }
          }
        })
      },
      ele_input(callback){
        var inputs = document.querySelector('.___input')
        if (!!inputs) {
          inputs.onchange = null
          inputs.onclick = null
          inputs.remove(0)
          // inputs.removeChild && inputs.removeChild(0)
        }
        var input = document.createElement('input')
        input.className = '___input'
        input.type = 'file'
        input.style.display = 'none'
        input.onchange = function() {
          var arr = []
          for (var i = 0, len = this.files.length; i < len; i++) {
            arr.push(this.files[i])
          }
          callback(arr)
        }
        input.accept = 'image/*'
        input.click();
        document.body.appendChild(input);
      },
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .rules{position: fixed;width: 100%;height: 100vh;left: 0;top: 0;background-color: #000000cc;}
    .rules .text1{color: #999;background-color: #fff;width: 80%;margin: 10% auto;padding: 20px;border-radius: 5px;}
    .ruletext{position: absolute;bottom: 20px;display: flex;align-items: center;width: 100%;}
    .ruletext .textb{text-align: center;width: 80%;margin: 0 10%;}
    .ruletext .text1{color: #00aaff;}
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
      margin-top: 50px;
      background: #f9f9f9;
      overflow-y: scroll;
    }
    .cotainer .cont{
      margin: 10px;
      padding: 0 .36rem 1.1rem;
      background-color: #fff;
      box-shadow: 0 0 5px 2px
        rgba(24, 11, 0, 0.18);
      border-radius: 0.28rem;
    }
    .upload-tips{
      padding: .6rem 0 1.2rem;
      color: #fff;
      font-size: .48rem;
    }
    .upload-ul{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
    }
    .upload-ul .upload-li{
      width: 4.38rem;
      margin-bottom: .8rem;
      box-sizing: border-box;
      text-align: center;
    }
    .upload-ul .upload-li .upload{
      width: 4.38rem;
      height: 3rem;
    }
    .upload-ul .upload-li .text{
      margin-top: .4rem;
      color: #8b8b8b;
      font-size: .36rem;
      height: 50px;
    }
    .upload-tips2{
      padding: .4rem 0 .7rem;
      color: #696a6a;
      font-size: .36rem;
    }
    .upload-btn{
      height: 1.48rem;
      color: #fff;
      font-size: .5rem;
      line-height: 1.48rem;
      background-color: #000;
      border-radius: 0.72rem;
      text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/upload.vue